const GENERIC_FAILURE = 'Не удалось подключить, попробуйте ещё раз'

const MESSAGES: Record<string, string> = {
    WAITTHAI_INVALID_TOKEN: 'Неверный токен',
    WAITTHAI_HOST_INVALID: 'Проверьте адрес сервера: нужен https-адрес вида api.example.com',
    WAITTHAI_UNREACHABLE: 'Сервер WaitThai недоступен, попробуйте позже',
    WAITTHAI_RATE_LIMITED: 'Слишком много запросов, повторите через минуту',
    WAITTHAI_SALON_NOT_AVAILABLE: 'Этот салон недоступен для токена',
    WAITTHAI_ALREADY_CONNECTED: 'В этом проекте WaitThai уже подключён',
    WAITTHAI_SALON_ALREADY_CONNECTED: 'Этот салон уже подключён в другом проекте',
    WAITTHAI_SERVICE_UNAVAILABLE: GENERIC_FAILURE,
    WAITTHAI_INTERNAL: GENERIC_FAILURE,
    NETWORK: GENERIC_FAILURE,
}

/** Текст ошибки для пользователя по коду; для неизвестного кода - сообщение сервера. */
export function getWaitThaiErrorMessage(code: string, serverMessage?: string): string {
    return MESSAGES[code] || serverMessage || GENERIC_FAILURE
}
